<template>
  <div
    v-if="!useMobileLayout"
    class="mt-7 flex w-full items-center justify-end tablet-h:mt-6"
  >
    <slot />
  </div>
  <!-- On mobile bottom sheets, actions go in DialogHeader left/right slots -->
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'

const { isMobile } = useDevice()
const isModal = inject<boolean>('dialogModal', false)
const useMobileLayout = isMobile.value && !isModal
</script>
